module.exports = reflectorLookupService = {
  restEndPoint: '/api/2.2/rest',

  serverPath: '',

  doneQueue: [],

  setServerPath: function(path) {
    this.serverPath = path;
  },

  performLookup: function(doneCallback) {
    // we need to perform reflector lookup
    if (KV.platformConfig.reflectorLookup && KV.platformConfig.reflectorLookup.reflectors && KV.platformConfig.reflectorLookup.reflectors.length) {
      // lookup should postpone loading the player
      if (KV.platformConfig.reflectorLookup.required) {
        this.pollReflectors(KV.platformConfig.reflectorLookup.reflectors, doneCallback);
      } else {
        // lookup can be run in the background so let's start it and continue loading the player
        this.pollReflectors(KV.platformConfig.reflectorLookup.reflectors);
        doneCallback();
      }
      // no reflector lookup required - just load the player
    } else {
      doneCallback();
    }
  },

  pollReflectors: function(reflectors, done) {
    // lookup already performed - nothing to do here
    if (KV.platformConfig.reflectorLookup.completed) {
      if (done) {
        done();
      }
      return;
    }
    // enqueue done callback to execute it once the first IP is received
    if (done) {
      this.doneQueue.push(done);
    }

    if (KV.platformConfig.reflectorLookup.inProgress) {
      return;
    }

    KV.platformConfig.reflectorLookup.inProgress = true;

    var count = reflectors.length;
    var preferredReflectors = [];
    // send the address only when the lookup is required
    var addressSent = !KV.platformConfig.reflectorLookup.required;
    var sendingAddress = false;
    var sendAddressQueue = [];
    var that = this;

    reflectors.forEach(function(reflector) {
      this.pollReflector(reflector, success, checkFinished);
    }, this);

    function success(reflector, address) {
      if (reflector) {
        preferredReflectors.push(reflector.id);
      }
      // nothing else to do here, check if we're done
      if (addressSent) {
        checkFinished();
        // make sure we run postponed send attempts
        // even though they might not get sent, we still need to run checks on them to update counters
        if (sendAddressQueue.length) {
          success(null, sendAddressQueue.shift());
        }
        // send the received IP address to the app, this should give us a cookie for being so nice ;)
      } else {
        if (sendingAddress) {
          sendAddressQueue.push(address);
        } else {
          sendingAddress = true;

          that.sendIpAddress(address, function() {
            addressSent = true;
            sendingAddress = false;
            // successfully sent the IP address, at this point we should have the cookie set so we can start loading data
            complete();

            checkFinished();
            // make sure we run postponed send attempts
            // even though they might not get sent, we still need to run checks on them to update counters
            if (sendAddressQueue.length) {
              success(null, sendAddressQueue.shift());
            }
          }, function() {
            sendingAddress = false;
            // sending IP failed, let's with another address retrieved, if any
            if (sendAddressQueue.length) {
              success(null, sendAddressQueue.shift());
            } else {
              checkFinished();
            }
          });
        }
      }
    }

    function checkFinished() {
      count -= 1;
      // no more reflectors to test
      if (!count) {
        // if the done callback is still here, it means none of the reflectors responded on time
        complete();
        // send preferred reflectors when the lookup is required, or we have some reflectors that responded
        if (KV.platformConfig.reflectorLookup.required || preferredReflectors.length) {
          that.sendPreferredReflectors(preferredReflectors);
        }
      }
    }

    function complete() {
      KV.platformConfig.reflectorLookup.completed = true;
      KV.platformConfig.reflectorLookup.inProgress = false;

      that.doneQueue.forEach(function(done) {
        done();
      });

      that.doneQueue.length = 0;
    }
  },

  pollReflector: function(reflector, successCallback, errorCallback) {
    var xhr = new XMLHttpRequest();

    xhr.open('GET', reflector.url);
    xhr.timeout = KV.platformConfig.reflectorLookup.timeout || 1000;
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            var response = JSON.parse(xhr.responseText);
            successCallback(reflector, response.ip);
          } catch (e) {
            errorCallback();
          }
        } else {
          errorCallback();
        }
      }
    };
    xhr.send();
  },

  sendIpAddress: function(address, success, error) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', this.serverPath + this.restEndPoint + '/users/currentuser/session/address');
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (KV.csrfToken) {
      xhr.setRequestHeader('X-CSRF-TOKEN', KV.csrfToken);
    }
    xhr.withCredentials = true;
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          success();
        } else {
          error();
        }
      }
    };
    xhr.send(JSON.stringify({
      ip: address
    }));
  },

  sendPreferredReflectors: function(reflectors) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', this.serverPath + this.restEndPoint + '/users/currentuser/session/reflectors');
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (KV.csrfToken) {
      xhr.setRequestHeader('X-CSRF-TOKEN', KV.csrfToken);
    }
    xhr.withCredentials = true;
    xhr.send(JSON.stringify({
      preferredReflectors: reflectors
    }));
  }
};
